import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

export default function WhatsAppMetadataIcon() {
  return (
    <div className="itemMetadata-whatsAppIcon itemMetadata-fontawesome">
      <FontAwesomeIcon icon={faWhatsapp} />
    </div>
  );
}
